<template>
  <div class="min-h-dvh bg-(--surface-page) text-(--text-primary)">
    <slot name="header" />

    <main class="mx-auto w-full max-w-[1600px] px-4 py-5 sm:px-6 sm:py-7 xl:px-8">
      <slot />
    </main>

    <slot name="overlay" />
  </div>
</template>
